import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Statistics Component
// This component renders a SubjectTopics component for the Statistics subject
const Statistics = () => <SubjectTopics subjectId={6} title="Statistics" />;

export default Statistics; // Export the Statistics component
